import { forwardRef } from 'react';

import { WRAPPER, MARGIN } from 'shared/components/charts/BarChart/constants';
import { useChartContext } from 'shared/components/charts/BarChart/hooks';
import { Grid } from 'shared/components/charts/components/Grid';

import { Bars } from './components/Bars';
import { Wrapper } from './components/Wrapper';
import { XAxis } from './components/XAxis';

export const Chart = forwardRef((_, ref) => {
  const { wrapperWidth, width, yScale, yLabels } = useChartContext();

  return (
    <Wrapper ref={ref}>
      <svg display="block" width={wrapperWidth} height={WRAPPER.height}>
        <g transform={`translate(${MARGIN.left}, ${MARGIN.top})`}>
          <XAxis />
          <Bars />
          <Grid
            width={width}
            margin={MARGIN}
            yScale={yScale}
            yLabels={yLabels}
          />
        </g>
      </svg>
    </Wrapper>
  );
});
